module.exports = __webpack_public_path__ + "./han_6d9ac4fb1709e147c3c43278d9cfd180.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/han.png
// module id = 421
// module chunks = 0